<template>
  <div>
    <md-progress-spinner v-if="downloading" md-mode="indeterminate" :md-diameter="25" :md-stroke="2"/>
    <md-button v-else @click="doDownload">Download</md-button>
  </div>
</template>

<script>
  export default {
    props: {
      photos: Array,
      zipFileName: String,
    },
    data: () => ({ downloading: false }),
    mounted() {
      this.downloading = false;
    },
    watch: {
      photos() {
        this.downloading = false;
      },
      zipFileName() {
        this.downloading = false;
      },
    },
    methods: {
      doDownload() {
        this.downloading = true;
        const zipFileName = this.zipFileName || 'pictures.zip';
        const promises = _(this.photos)
          .map((photo) => {
            const a = document.createElement('a');
            a.href = photo.photoUrl;

            const req = {
              method: 'GET',
              mode: 'no-cors',
              cache: 'default',
            };

            const pathName = a.pathname;
            console.log(pathName);
            return fetch(pathName, req)
              .then(response => ({
                response,
                photo,
              }));
          });


        Promise.all(promises)
          .then((results) => {
            this.downloading = false;
            console.log(`aa`, results);
            const zip = new JSZip();
            _.chain(results)
              .groupBy(it => it.photo.containerNo)
              .each((values, k) => {
                const target = (`${k}` !== `null`) ? zip.folder(k) : zip;
                _(values)
                  .each(({ response,photo }) => {
                    const res = response;
                    let filename = photo.photoName || decodeURI(res.url.replace(/.*\//g, ""));
                    if (!filename.endsWith('png') || !filename.endsWith('jpg')) {
                      filename += '.png';
                    }
                    console.log(`filename=${filename}`);
                    const blob = res.blob();
                    target.file(filename, blob, { binary: true });
                  });
              });

            zip.generateAsync({ type: "blob" })
              .then((blob) => {
                const a = $("<a style='display: none;'/>");
                const url = window.URL.createObjectURL(blob);
                a.attr("href", url);
                a.attr("download", zipFileName);
                $("body")
                  .append(a);
                a[0].click();
                window.URL.revokeObjectURL(url);
                a.remove();
              });
          })
          .catch((e) => {
            console.error(e);
            this.downloading = false;
          });
      },
    },
  };
</script>
